import { Alert, Box, Button, Card, CardContent, CardHeader, CircularProgress, Divider, Tooltip, Typography } from '@mui/material';
import { MainContainer, MainHeading } from '../../style/GlobalStyles';
import { useEffect, useRef, useState } from 'react';
import Steps from './Steps';
import GeneralScreen from './GeneralScreen';
import ConfirmationScreen from './ConfirmationScreen';
import { useSearchParams } from 'react-router-dom';
import { get, post } from '../../api';
import dayjs from 'dayjs';
import RepeatableScreen from './RepeatableScreen';
import { shouldQuestionOrScreenVisible } from './Questions';
import { LoadingButton } from '@mui/lab';
import { dummyData } from './dummyData';
import InstructionScreen from './InstructionScreen';
import RenderContent from '../../components/RenderContent';
import TextDisplay from '../../components/TextDisplay';
import { useAuth } from '../../hooks/useAuth';
import NoDataPresentUI from '../../components/NoDataPresentUI';
import BlankIcon from '../../icons/BlankIcon';
import logo from '../../assets/logo/Logo.svg';

import LockIcon from '@mui/icons-material/Lock';

const STATUS_CONSTANTS = {
    notStarted: 'Not Started',
    inProgress: 'In Progress',
    submitted: 'Submitted',
};
let localAllScreenData = [];

function PrimeAssessment({ mode, withLogin }) {
    const [allScreenData, setAllScreenData] = useState([]);
    const [allData, setAllData] = useState({});
    const [allDataError, setAllDataError] = useState('');
    const [justSubmitted, setJustSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [skipButtonLoading, setSkipButtonLoading] = useState(false);
    const [isLoadingReviewAnswers, setIsLoadingReviewAnswers] = useState(false);
    const [displaySummaryScreen, setDisplaySummaryScreen] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [repeatScreenError, setRepeatScreenError] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const [status, setStatus] = useState(STATUS_CONSTANTS.notStarted); // state tells form survey is started or not.
    const { getUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();

    const repeatScreenRef = useRef();
    const isFirstRenderRef = useRef(false);

    const [completionActions, setCompletionActions] = useState([]);

    const [publicResponseId, setPublicResponseId] = useState(searchParams.get('publicResponseId'));

    const NavigateExternalURL = ({ url, reviewSurvey }) => {
        useEffect(() => {
            if (reviewSurvey === 'yes') {
                const next = new URLSearchParams(searchParams); // keeps other params
                next.set('review-survey', 'no'); // change just one param
                setSearchParams(next, { replace: true });
                setCurrentStep(0);
                setAllData((prevData) => ({
                    ...prevData,
                    lastVisitedScreenId: '',
                    status: 'Submitted',
                }));
            } else {
                window.location.replace(url);
            }
        }, []);

        return <div></div>; // or null
    };

    useEffect(() => {
        if (!isFirstRenderRef.current) {
            // in dev mode calling api two times create inconsistancy in allScreenData and localAllScreenData data
            // so prevent it and call only once
            isFirstRenderRef.current = true;
            handleGetSurvey();
        }
    }, []);

    const handleGetSurvey = (isReviewClicked) => {
        const surveyId = searchParams.get('surveyId');
        const contactId = searchParams.get('contactId');
        if (surveyId && (contactId || mode === 'public')) {
            setLoading(true);
            setAllDataError('');
            if (withLogin && !userDetails?.contact?.id) {
                return;
            }

            post(mode === 'public' ? `custom/getSurveyWithAnswerPublic` : `custom/getSurveyWithAnswer`, {
                recordId: surveyId,
                contactId: withLogin ? userDetails.contact.id : contactId ? contactId : '',
                mode: mode,
                publicResponseId: searchParams.get('publicResponseId'),
            }).then((result) => {
                if (result.isSuccess) {
                    let data = result.data;
                    if (data.actions?.length) {
                        setCompletionActions(data.actions);
                    }
                    if (isReviewClicked) {
                        data = {
                            ...data,
                            lastVisitedScreenId: '',
                        };
                    }
                    if (data.uniqueId) {
                        setPublicResponseId(data.uniqueId);
                        const next = new URLSearchParams(searchParams);
                        next.set('publicResponseId', data.uniqueId);
                        setSearchParams(next, { replace: true });
                    }
                    setAllData(data);
                    setLoading(false);
                    if (data) {
                        setAllScreenData(data.screens);
                        localAllScreenData = data.screens;

                        if (data.status === 'Not Started') {
                            console.log(`data.status === 'Not Started`);
                            setCurrentStep('');
                            setStatus(STATUS_CONSTANTS.notStarted);
                        } else if (data.status === 'Submitted') {
                            console.log(`data.status === 'Submitted`);
                            setCurrentStep(!data.lastVisitedScreenId ? 0 : data.screens.length);
                            setStatus(STATUS_CONSTANTS.submitted);
                        } else if (data.status === 'In Progress') {
                            const index = data.screens.findIndex((c) => c.Id === data.lastVisitedScreenId);
                            const idx = index >= 0 ? index : 0;
                            setCurrentStep(idx);
                            setStatus(STATUS_CONSTANTS.inProgress);
                            console.log(`data.status === 'Progress index, idx`);
                        }
                    }
                } else {
                    console.log('getSurveyWithAnswer result Error: ', result);
                    setLoading(false);
                    setAllDataError(result?.errorMessage || 'Something went wrong.');
                }
            });
        } else {
            setAllScreenData([]);
            localAllScreenData = [];
        }
    };

    const evaluateQuestionsList = (data = { allScreenData: null, currentStep: null }) => {
        // For questions
        // view => question || screen

        let questionsList = [];

        const currentScreenStep = data.currentStep ? data.currentStep : currentStep;
        const allScreenDataList = data.allScreenData ? (data.allScreenData?.length > 0 ? data.allScreenData : []) : localAllScreenData;

        for (let index = 0; index <= currentScreenStep; index++) {
            const screen = allScreenDataList[index];
            const questions = screen?.Questions__r?.records || [];

            if (screen?.Type__c === 'Repeatable') {
                continue;
                /*
                console.log('is it working?....');
                const cardList = screen?.cardList || [];

                const mapQuestionWithAnswers = new Map();

                for (let index = 0; index < cardList.length; index++) {
                    const card = cardList[index];
                    const cardQuestions = card.questions;

                    for (let index = 0; index < cardQuestions.length; index++) {
                        const cardQuestion = cardQuestions[index];
                        const Id = cardQuestion?.Id;
                        const answer = cardQuestion?.answer;

                        if (mapQuestionWithAnswers.has(Id)) {
                            // If already exists, push to the existing list
                            mapQuestionWithAnswers.get(Id).push(answer);
                        } else {
                            // Else create a new list
                            mapQuestionWithAnswers.set(Id, [answer]);
                        }
                    }
                }

                for (const [key, value] of mapQuestionWithAnswers) {
                    console.log('Key:', key, 'Value:', value);
                }

                const updatedQuestions = [];
                for (let index = 0; index < questions.length; index++) {
                    const question = questions[index];
                    delete question.answer;

                    if (mapQuestionWithAnswers.has(question?.Id)) {
                        updatedQuestions.push({
                            ...question,
                            answerList: mapQuestionWithAnswers.get(question?.Id) || [],
                        });
                    }
                }

                console.log('updatedQuestions...', updatedQuestions);

                questionsList = [...questionsList, ...updatedQuestions];
                */
            } else {
                questionsList = [...questionsList, ...questions];
            }
        }

        return questionsList;
    };

    const validate = (question = {}) => {
        if (question.Type__c === 'Date') {
            if (!question.answer) {
                return 'This field is required. Please provide a valid response.';
            }
            if (!dayjs(question.answer).isValid()) {
                return 'Please enter a valid date';
            }
        }

        if (question.Type__c === 'File') {
            if (!question.answer || parseInt(question.answer) === 0) {
                return 'Please upload at least one file';
            }
        }

        const answer = question?.answer ?? '';
        if (!String(answer).trim()) {
            return 'This field is required. Please provide a response.';
        }
        return '';
    };

    const handleNextButton = (data = { isScreenSkipButtonClicked: false }) => {
        // debugger;
        const screenToValidate = localAllScreenData[currentStep];
        const questionsToValidate = screenToValidate?.Questions__r?.records || [];
        const questionsListToValidate = evaluateQuestionsList() || [];

        const validatedQuestions = questionsToValidate.map((cQuestion) => {
            const shouldVisible = shouldQuestionOrScreenVisible({
                conditionalRequirement: cQuestion?.Condition_Requirement__c,
                conditionalLogic: cQuestion?.Condition_Logic__c,
                conditionList: cQuestion?.Conditions2__r?.records,
                questionList: questionsListToValidate,
            });
            if (!shouldVisible) {
                if (cQuestion.hasOwnProperty('error')) {
                    delete cQuestion.error;
                }
                if (cQuestion.hasOwnProperty('answer')) {
                    delete cQuestion.answer;
                }
                return {
                    ...cQuestion,
                    skipped: true,
                };
            }

            let q = { ...cQuestion, skipped: false };

            if (!data.isScreenSkipButtonClicked && (cQuestion.Is_Required__c === 'Yes' || !cQuestion.Is_Required__c)) {
                const error = validate(cQuestion);
                if (error) {
                    return {
                        ...q,
                        error,
                    };
                } else {
                    if (q.hasOwnProperty('error')) {
                        delete q.error;
                    }
                    return q;
                }
            }

            if (data.isScreenSkipButtonClicked) {
                if (q.hasOwnProperty('error')) {
                    delete q.error;
                }
                return q;
            }

            return q;
        });
        const updatedScreens = localAllScreenData.map((cScreen, index) => {
            if (index === currentStep) {
                return {
                    ...cScreen,
                    Is_Screen_Skipped__c: data.isScreenSkipButtonClicked,
                    Questions__r: {
                        ...cScreen.Questions__r,
                        records: validatedQuestions,
                    },
                };
            }

            return cScreen;
        });
        setAllScreenData(updatedScreens);
        localAllScreenData = updatedScreens;

        const errors = validatedQuestions.filter((cQuestion) => {
            if (cQuestion.error) {
                return true;
            }
            return false;
        });

        if (Object.keys(errors).length === 0) {
            if (currentStep === localAllScreenData.length - 1) {
                // last screen
                handleNextSubmit({
                    callback: () => {
                        setCurrentStep((prevStep) => localAllScreenData.length);
                        setStatus(STATUS_CONSTANTS.submitted);
                    },
                    updatedScreen: localAllScreenData[currentStep],
                    isLastScreen: true,
                    isScreenSkipButtonClicked: data.isScreenSkipButtonClicked,
                    isLock: getIsLock(),
                    // lastVisitedScreenId : null
                });
                setJustSubmitted(true);
            } else if (currentStep < localAllScreenData.length) {
                // For screen validation
                updateScreenWithSkippedValues({ isScreenSkipButtonClicked: data.isScreenSkipButtonClicked, isLock: getIsLock() });
            }
        }
    };
    const handleRepeatableScreenNextButton = (data = { isScreenSkipButtonClicked: false }) => {
        const screenToValidate = localAllScreenData[currentStep];
        // const questionsToValidate = screenToValidate?.Questions__r?.records || [];
        // const questionsListToValidate = evaluateQuestionsList() || [];

        let updateInCurrentScreen = {
            Is_Screen_Skipped__c: data.isScreenSkipButtonClicked,
        };

        if (!data.isScreenSkipButtonClicked) {
            const newCardScreenList = repeatScreenRef.current?.allCardsDataSaveHandler();
            const cardLength = newCardScreenList?.length || 0;
            const requiredLength = screenToValidate?.Minimun_Records__c;

            if (!newCardScreenList) {
                // handle errors in card itself
                return;
            } else if (newCardScreenList && screenToValidate?.Minimun_Records__c !== null && cardLength < requiredLength) {
                // handle card length error
                setRepeatScreenError(`Please fill out at least ${requiredLength} card.`);
                return;
            } else {
                setRepeatScreenError('');
            }

            updateInCurrentScreen = {
                ...updateInCurrentScreen,
                cardList: newCardScreenList,
            };
        }

        const updatedScreens = localAllScreenData.map((cScreen, index) => {
            if (index === currentStep) {
                return {
                    ...cScreen,
                    ...updateInCurrentScreen,
                };
            }

            return cScreen;
        });
        setAllScreenData(updatedScreens);
        localAllScreenData = updatedScreens;

        if (currentStep === localAllScreenData.length - 1) {
            // last screen
            // handleSubmit();
            handleNextSubmit({
                callback: () => {
                    setCurrentStep((prevStep) => localAllScreenData.length);
                    setStatus(STATUS_CONSTANTS.submitted);
                },
                updatedScreen: localAllScreenData[currentStep],
                isLastScreen: true,
                isScreenSkipButtonClicked: data.isScreenSkipButtonClicked,
                isLock: getIsLock(),
                // lastVisitedScreenId : null
            });
            setJustSubmitted(true);
        } else if (currentStep < localAllScreenData.length) {
            // screen validations
            updateScreenWithSkippedValues({ isScreenSkipButtonClicked: data.isScreenSkipButtonClicked, isLock: getIsLock() });
        }
    };

    const getSkippedQuestions = () => {
        let skippedScreens = localAllScreenData.filter((item) => item.Is_Screen_Skipped__c); // screen which are skipped by skip button
        const questionsListToValidate = evaluateQuestionsList() || [];
        if (skippedScreens?.length > 0) {
            let questions = [];
            for (let screen of skippedScreens) {
                // check screen should visible
                // removing screen which are conditionally not visible
                const shouldVisible = shouldQuestionOrScreenVisible({
                    conditionalRequirement: screen?.Condition_Requirement__c,
                    conditionalLogic: screen?.Condition_Logic__c,
                    conditionList: screen?.Conditions1__r?.records,
                    questionList: questionsListToValidate,
                });
                if (!shouldVisible) {
                    continue;
                }
                if (screen.Type__c !== 'Repeatable') {
                    // check this screen that question visibled or not (using question.isVisible)
                    for (let question of screen.Questions__r?.records) {
                        if ((question.Is_Required__c === 'Yes' || !question.Is_Required__c) && !question.answer && question.isVisible) {
                            questions.push({ ...question, screenName: screen.Name });
                        }
                    }
                } else {
                    const cardLength = screen?.cardList?.length || 0;
                    const requiredLength = screen?.Minimun_Records__c;

                    // check this repeatable screen that at least one question visibled or not (using isScreenVisibled)
                    const isScreenVisibled = screen?.Questions__r?.records?.some((question) => {
                        const shouldVisible = shouldQuestionOrScreenVisible({
                            conditionalRequirement: question?.Condition_Requirement__c,
                            conditionalLogic: question?.Condition_Logic__c,
                            conditionList: question?.Conditions2__r?.records,
                            questionList: questionsListToValidate,
                        });
                        if (shouldVisible) {
                            return true;
                        }
                        return false;
                    });

                    if (isScreenVisibled && screen?.Minimun_Records__c !== null && cardLength < requiredLength) {
                        const remainingRecords = requiredLength - cardLength;
                        questions.push({ Screen__c: screen.Id, Label__c: `You need to add at least ${remainingRecords} more record${remainingRecords > 1 ? 's' : ''}.`, screenName: screen.Name });
                    }
                }
            }
            return questions;
        }

        return [];
    };

    const checkIsAnyAnswerChange = () => {
        // this will check in all anwsers, do they chanages
        let isChangesHappen = false;
        const savedScreens = allData?.screens || [];
        const updatedScreens = localAllScreenData || [];

        const normalize = (val) => {
            return val === null || val === undefined || val === '' ? null : val;
        };

        for (let index = 0; index < updatedScreens.length; index++) {
            const alreadySavedScreen = savedScreens[index];
            const alreadySavedScreenQuestions = alreadySavedScreen?.Questions__r?.records || [];

            const updatedScreen = updatedScreens[index];
            const updatedScreenQuestions = updatedScreen?.Questions__r?.records || [];

            if (updatedScreen?.Type__c !== 'Repeatable') {
                for (let index = 0; index < updatedScreenQuestions.length; index++) {
                    const updatedQuestion = updatedScreenQuestions[index];
                    const savedQuestion = alreadySavedScreenQuestions?.find((c) => c.Id === updatedQuestion?.Id);

                    const t1 = normalize(savedQuestion?.answer);
                    const t2 = normalize(updatedQuestion?.answer);

                    if (t1 !== t2) {
                        isChangesHappen = true;
                        break;
                    }
                }
            } else {
                const alreadySavedScreenCardList = alreadySavedScreen?.cardList || [];
                const updatedScreenCardList = updatedScreen?.cardList || [];

                if (alreadySavedScreenCardList.length !== updatedScreenCardList.length) {
                    isChangesHappen = true;
                    break;
                } else {
                    for (let index = 0; index < updatedScreenCardList.length; index++) {
                        const updatedCard = updatedScreenCardList[index];
                        const savedCard = alreadySavedScreenCardList?.find((c) => c.id === updatedCard?.id);

                        if (!savedCard) {
                            isChangesHappen = true;
                            break;
                        } else {
                            const savedCardQuestions = savedCard?.questions || [];
                            const updatedCardQuestions = updatedCard?.questions || [];

                            for (let index = 0; index < updatedCardQuestions.length; index++) {
                                const updatedQuestion = updatedCardQuestions[index];
                                const savedQuestion = savedCardQuestions?.find((c) => c.Id === updatedQuestion?.Id);

                                const t1 = normalize(savedQuestion?.answer);
                                const t2 = normalize(updatedQuestion?.answer);

                                if (t1 !== t2) {
                                    isChangesHappen = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        return isChangesHappen;
    };

    const getDefaultCardScreen = () => {
        const questionsList = currentScreenData?.Questions__r?.records || [];
        const cardQuestionsList = questionsList?.map((c) => {
            return {
                questionId: c?.Id,
                answer: null,
                isVisible: c.isVisible,
            };
        });
        const newCardScreen = {
            id: `${Math.random()}`,
            questions: [...cardQuestionsList],
            filesId: `${Math.random()}`,
        };

        return newCardScreen;
    };

    const handleNextSubmit = (data = { updatedScreen: {}, callback: () => {}, isLastScreen: false, lastVisitedScreenId: '', isScreenSkipButtonClicked: false, isLock: false }) => {
        const cScreen = data.updatedScreen;
        let postData = {};

        // skipped if condtion not full fill
        // isScreenSkipButtonClicked if skipp button clicked

        if (cScreen?.Type__c === 'Repeatable') {
            const customiseCardList = cScreen?.cardList?.map((card) => {
                return {
                    filesId: card.filesId,
                    questions: card?.questions?.map((cQuestion) => {
                        return {
                            questionId: cQuestion?.Id,
                            answer: cQuestion.skipped ? '' : cQuestion?.answer,
                            isVisible: cQuestion.isVisible,
                        };
                    }),
                };
            });
            const isEmpty = !cScreen?.cardList?.length || cScreen?.cardList?.length <= 0;
            const cardList = isEmpty ? [getDefaultCardScreen()] : customiseCardList;

            if (data.isScreenSkipButtonClicked) {
                postData = {
                    screenId: cScreen?.Id,
                    cardList: cardList,
                    isEmpty: isEmpty ? true : false, // isEmpty means skipped button clicked and cardlist is empty
                };
            } else {
                postData = {
                    screenId: cScreen?.Id,
                    cardList: customiseCardList,
                    isEmpty: false,
                };
            }
        } else {
            const questions =
                cScreen?.Questions__r?.records?.map((cQuestion) => {
                    return {
                        questionId: cQuestion?.Id,
                        answer: cQuestion?.skipped ? '' : cQuestion?.answer,
                        isVisible: cQuestion.isVisible,
                    };
                }) || [];
            postData = {
                screenId: cScreen?.Id,
                questions: questions,
            };
        }

        let skippedQuestions = getSkippedQuestions();

        let status =
            data.isLastScreen || getIsLock()
                ? 'Submitted'
                : getIsNotLock()
                  ? !checkIsAnyAnswerChange()
                      ? 'Submitted'
                      : 'In Progress'
                  : currentStep >= 0 && currentStep < localAllScreenData.length - 1
                    ? 'In Progress'
                    : 'Not Started';

        let lastVisitedScreenId =
            data?.lastVisitedScreenId && !getIsLock()
                ? getIsNotLock()
                    ? !checkIsAnyAnswerChange()
                        ? 'Last Screen'
                        : data?.lastVisitedScreenId
                    : data?.lastVisitedScreenId
                : skippedQuestions?.length > 0
                  ? 'Summery Screen'
                  : 'Last Screen';

        postData = {
            ...postData,
            publicResponseId: publicResponseId,
            surveyId: searchParams.get('surveyId'),
            contactId: withLogin ? userDetails.contact.id : searchParams.get('contactId'),
            status,
            lastVisitedScreenId: lastVisitedScreenId,
            isScreenSkipped: data.isScreenSkipButtonClicked ? true : false,
            screenType: cScreen?.Type__c,
        };

        data.isScreenSkipButtonClicked ? setSkipButtonLoading(true) : setPostLoading(true);

        if (postData.lastVisitedScreenId === 'Summery Screen') {
            postData.status = 'In Progress';
        }
        data.isScreenSkipButtonClicked ? setSkipButtonLoading(false) : setPostLoading(false);
        data.callback();

        if (withLogin && !userDetails?.contact?.id) {
            return;
        }

        post(mode === 'public' ? `custom/updateSurveyScreenPublic` : `custom/updateSurveyScreen`, {
            data: JSON.stringify(postData),
        }).then((result) => {
            if (result.isSuccess) {
                console.log('success: ', result.data);
                if (result.data && result.data?.length > 20) {
                    setPublicResponseId(result.data);
                    const next = new URLSearchParams(searchParams);
                    next.set('publicResponseId', result.data);
                    setSearchParams(next, { replace: true });
                }
            } else {
                console.log('result Error: ', result);
            }
        });

        if (postData.lastVisitedScreenId === 'Summery Screen') {
            setDisplaySummaryScreen(true);
        }
    };

    const handleRepeatableDataSave = (newCardList) => {
        if (newCardList?.length) {
            setRepeatScreenError('');
        }

        const screen = localAllScreenData[currentStep];

        const updatedScreen = {
            ...screen,
            cardList: newCardList,
        };

        const updatedScreens = localAllScreenData.map((cScreen, index) => {
            if (index === currentStep) {
                return {
                    ...cScreen,
                    ...updatedScreen,
                };
            }

            return cScreen;
        });

        setAllScreenData(updatedScreens);
        localAllScreenData = updatedScreens;
    };

    const updateScreenWithSkippedValues = (data = { isScreenSkipButtonClicked: false, isLock: false }) => {
        const questionsListToValidate = evaluateQuestionsList() || [];

        const nextScreen = localAllScreenData[currentStep + 1];
        const currentScreen = localAllScreenData[currentStep];

        let updatedScreens = localAllScreenData.map((scr) => {
            if (currentScreen.Id === scr.Id) {
                return {
                    ...scr,
                    Is_Screen_Skipped__c: data.isScreenSkipButtonClicked,
                };
            }
            return {
                ...scr,
            };
        });

        setAllScreenData(updatedScreens);
        localAllScreenData = updatedScreens;

        // check next screen should visible
        const shouldVisible = shouldQuestionOrScreenVisible({
            conditionalRequirement: nextScreen?.Condition_Requirement__c,
            conditionalLogic: nextScreen?.Condition_Logic__c,
            conditionList: nextScreen?.Conditions1__r?.records,
            questionList: questionsListToValidate,
        });

        // if screen should visible then check on that screen at least one question to show
        const questionListOnConditions = nextScreen?.Questions__r?.records?.filter((cQuestion) => {
            const shouldVisible = shouldQuestionOrScreenVisible({
                conditionalRequirement: cQuestion?.Condition_Requirement__c,
                conditionalLogic: cQuestion?.Condition_Logic__c,
                conditionList: cQuestion?.Conditions2__r?.records,
                questionList: questionsListToValidate,
            });
            if (shouldVisible) {
                return true;
            }
            return false;
        });

        if (shouldVisible && questionListOnConditions?.length > 0) {
            handleNextSubmit({
                callback: () => {
                    setCurrentStep((prevStep) => prevStep + 1); //0, 1, 2, 3
                },
                updatedScreen: localAllScreenData[currentStep], // current screen
                lastVisitedScreenId: localAllScreenData?.[currentStep + 1]?.Id || '',
                isScreenSkipButtonClicked: data.isScreenSkipButtonClicked,
            });
        } else {
            let steps = 2;
            let screenIds = [];
            screenIds.push(nextScreen?.Id);

            for (let index = currentStep + steps; index < localAllScreenData.length; index++) {
                const nextScreen = localAllScreenData[index];
                const shouldVisible = shouldQuestionOrScreenVisible({
                    conditionalRequirement: nextScreen?.Condition_Requirement__c,
                    conditionalLogic: nextScreen?.Condition_Logic__c,
                    conditionList: nextScreen?.Conditions1__r?.records,
                    questionList: questionsListToValidate,
                });

                const questionListOnConditions = nextScreen?.Questions__r?.records?.filter((cQuestion) => {
                    const shouldVisible = shouldQuestionOrScreenVisible({
                        conditionalRequirement: cQuestion?.Condition_Requirement__c,
                        conditionalLogic: cQuestion?.Condition_Logic__c,
                        conditionList: cQuestion?.Conditions2__r?.records,
                        questionList: questionsListToValidate,
                    });
                    if (shouldVisible) {
                        return true;
                    }
                    return false;
                });

                if (shouldVisible && questionListOnConditions?.length > 0) {
                    break;
                } else {
                    if (!screenIds.includes(nextScreen?.Id)) {
                        screenIds.push(nextScreen?.Id);
                    }
                    steps = steps + 1;
                }
            }

            updatedScreens = updatedScreens.map((scr) => {
                if (screenIds.includes(scr.Id)) {
                    return {
                        ...scr,
                        // skipped: data.isScreenSkipButtonClicked,
                        // Note: Is_Screen_Skipped__c used for skip screen by skip button
                        // Note: skipped used for skipped screens by conditional logic(screens not visible)
                        Is_Screen_Skipped__c: data.isScreenSkipButtonClicked,
                        skipped: true,
                    };
                }
                return {
                    ...scr,
                };
            });

            setAllScreenData(updatedScreens);
            localAllScreenData = updatedScreens;

            // console.log('updatedScreens screenIds', updatedScreens, screenIds);

            if (currentStep + steps >= localAllScreenData.length) {
                // last screen
                // handleSubmit(updatedScreens);
                handleNextSubmit({
                    callback: () => {
                        setCurrentStep((prevStep) => localAllScreenData.length);
                        setStatus(STATUS_CONSTANTS.submitted);
                    },
                    updatedScreen: localAllScreenData[currentStep],
                    isLastScreen: true,
                    isScreenSkipButtonClicked: data.isScreenSkipButtonClicked,
                    isLock: data.isLock,
                    // lastVisitedScreenId : null
                });
                setJustSubmitted(true);
            } else {
                handleNextSubmit({
                    callback: () => {
                        setCurrentStep((prevStep) => prevStep + steps);
                    },
                    updatedScreen: localAllScreenData[currentStep],
                    lastVisitedScreenId: localAllScreenData?.[currentStep + steps]?.Id || '',
                    isScreenSkipButtonClicked: data.isScreenSkipButtonClicked,
                    isLock: data.isLock,
                });
            }
        }
    };

    const getConditionallySkippedScreensIds = (currentStep, allScreenData) => {
        // this function return ids of screens which are skipped conditionally not by skip button
        let conditiinallySkippedScreens = [];
        for (let index = 1; index < currentStep; index++) {
            const currentScreen = allScreenData[index];
            const questionsListToValidate = evaluateQuestionsList({ allScreenData: allScreenData, currentStep: index - 1 }) || [];

            const shouldVisible = shouldQuestionOrScreenVisible({
                conditionalRequirement: currentScreen?.Condition_Requirement__c,
                conditionalLogic: currentScreen?.Condition_Logic__c,
                conditionList: currentScreen?.Conditions1__r?.records,
                questionList: questionsListToValidate,
            });

            const questionListOnConditions = currentScreen?.Questions__r?.records?.filter((cQuestion) => {
                const shouldVisible = shouldQuestionOrScreenVisible({
                    conditionalRequirement: cQuestion?.Condition_Requirement__c,
                    conditionalLogic: cQuestion?.Condition_Logic__c,
                    conditionList: cQuestion?.Conditions2__r?.records,
                    questionList: questionsListToValidate,
                });
                if (shouldVisible) {
                    return true;
                }
                return false;
            });

            if (shouldVisible && questionListOnConditions?.length > 0) {
                conditiinallySkippedScreens = conditiinallySkippedScreens.filter((id) => id !== currentScreen.Id);
            } else {
                if (!conditiinallySkippedScreens.includes(currentScreen.Id)) {
                    conditiinallySkippedScreens = [...conditiinallySkippedScreens, currentScreen.Id];
                }
            }
        }
        return conditiinallySkippedScreens;
    };

    const handleBackStep = () => {
        if (currentStep > 0) {
            // if reload happens skipped can be set null for previous screens so check previous screens here again

            const conditionallySkippedScreensIds = getConditionallySkippedScreensIds(currentStep, localAllScreenData);

            let steps = 1;
            const screenIds = [];
            for (let index = currentStep - steps; index >= 0; index--) {
                const prevScreen = localAllScreenData[index];
                const t1 = conditionallySkippedScreensIds.includes(prevScreen.Id);
                const t2 = prevScreen.Is_Screen_Skipped__c;
                // if (t1 || t2) {
                //     steps = steps + 1;
                //     screenIds.push(prevScreen?.Id);
                // } else {
                //     break;
                // }
                if (t1 && t2) {
                    steps = steps + 1;
                    screenIds.push(prevScreen?.Id);
                } else if (t1) {
                    steps = steps + 1;
                    screenIds.push(prevScreen?.Id);
                } else {
                    break;
                }
            }
            if (currentStep - steps >= 0) {
                setCurrentStep((prevStep) => prevStep - steps);
            } else {
                // setCurrentStep(0);
            }

            const updatedScreens = localAllScreenData.map((scr) => {
                if (screenIds.includes(scr.Id)) {
                    return {
                        ...scr,
                        skipped: false,
                    };
                }
                return {
                    ...scr,
                };
            });

            setAllScreenData(updatedScreens);
            localAllScreenData = updatedScreens;
        }
    };

    const handleSetVisibility = (value, questionId, screenIndex, cardId) => {
        const updatedScreens = localAllScreenData.map((cScreen, index) => {
            if (index === screenIndex && cScreen?.Type__c === 'General') {
                return {
                    ...cScreen,
                    Questions__r: {
                        ...cScreen.Questions__r,
                        records: cScreen.Questions__r.records.map((item) => {
                            if (item.Id === questionId) {
                                return { ...item, isVisible: value, skipped: !value };
                            }
                            return item;
                        }),
                    },
                };
            }

            if (index === screenIndex && cScreen?.Type__c === 'Repeatable') {
                return {
                    ...cScreen,
                    cardList: cScreen.cardList?.map((card) => {
                        if (card?.id === cardId) {
                            return {
                                ...card,
                                questions: card.questions.map((item) => {
                                    if (item.Id === questionId) {
                                        return { ...item, isVisible: value, skipped: !value };
                                    }
                                    return item;
                                }),
                            };
                        }
                        return card;
                    }),
                };
            }

            return cScreen;
        });
        //setAllScreenData(updatedScreens);
        localAllScreenData = updatedScreens;
    };

    const handleSetValues = (prevAllScreens, value, questionId, screenIndex, notValidate) => {
        notValidate = notValidate && !value;
        const screen = prevAllScreens[screenIndex];
        const questions = screen?.Questions__r?.records || [];
        const questionsListToValidate = evaluateQuestionsList() || [];
        const question = questions.find((c) => c.Id === questionId);

        const answerValue = typeof value === 'string' ? value.trim() : value;
        const updatedQuestionWithAnwser = {
            ...question,
            answer: answerValue,
        };

        const updatedQuestions = questions.map((cQuestion) => {
            if (cQuestion.Id === question.Id) {
                return updatedQuestionWithAnwser;
            }
            return cQuestion;
        });

        const validatedQuestions = updatedQuestions.map((cQuestion) => {
            const shouldVisible = shouldQuestionOrScreenVisible({
                conditionalRequirement: cQuestion?.Condition_Requirement__c,
                conditionalLogic: cQuestion?.Condition_Logic__c,
                conditionList: cQuestion?.Conditions2__r?.records,
                questionList: questionsListToValidate,
            });

            if (!shouldVisible) {
                if (cQuestion.hasOwnProperty('error')) {
                    delete cQuestion.error;
                }
                return cQuestion;
            }
            if ((cQuestion?.Is_Required__c === 'Yes' || !cQuestion?.Is_Required__c) && cQuestion.Id === questionId && !notValidate) {
                const error = validate(cQuestion);
                if (error) {
                    return {
                        ...cQuestion,
                        error,
                    };
                } else {
                    if (cQuestion.hasOwnProperty('error')) {
                        delete cQuestion.error;
                    }
                }
            }

            return cQuestion;
        });

        const updatedScreens = prevAllScreens.map((cScreen, index) => {
            if (index === screenIndex) {
                return {
                    ...cScreen,
                    Questions__r: {
                        ...cScreen.Questions__r,
                        records: validatedQuestions,
                    },
                };
            }

            return cScreen;
        });

        return [...updatedScreens];
    };

    const handleDataChange = (value, questionId, screenIndex, notValidate, isDefaultValue) => {
        const updatedScreens = handleSetValues(localAllScreenData, value, questionId, screenIndex, notValidate);
        localAllScreenData = updatedScreens;
        setAllScreenData(updatedScreens);
    };

    // console.log('allScreenData data: ', allScreenData);
    // console.log('localAllScreenData: ', localAllScreenData);

    const evaluateButtonText = () => {
        const screenToValidate = localAllScreenData[currentStep];
        const questionsToValidate = screenToValidate?.Questions__r?.records || [];
        const questionsListToValidate = evaluateQuestionsList() || [];

        let text = 'Next';
        if (currentStep === localAllScreenData.length - 1) {
            text = 'Submit';
        } else if (currentStep < localAllScreenData.length) {
            // 0, 1, [2, 3, 4] , cf
            const nextScreen = localAllScreenData[currentStep + 1];
            const screenIds = [];

            const shouldVisible = shouldQuestionOrScreenVisible({
                conditionalRequirement: nextScreen?.Condition_Requirement__c,
                conditionalLogic: nextScreen?.Condition_Logic__c,
                conditionList: nextScreen?.Conditions1__r?.records,
                questionList: questionsListToValidate,
            });

            const questionListOnConditions = nextScreen?.Questions__r?.records?.filter((cQuestion) => {
                const shouldVisible = shouldQuestionOrScreenVisible({
                    conditionalRequirement: cQuestion?.Condition_Requirement__c,
                    conditionalLogic: cQuestion?.Condition_Logic__c,
                    conditionList: cQuestion?.Conditions2__r?.records,
                    questionList: questionsListToValidate,
                });
                if (shouldVisible) {
                    return true;
                }
                return false;
            });

            if (shouldVisible && questionListOnConditions?.length > 0) {
                text = 'Next';
            } else {
                let steps = 2;
                screenIds.push(nextScreen?.Id);

                for (let index = currentStep + 2; index < localAllScreenData.length; index++) {
                    const nextScreen = localAllScreenData[index];
                    const shouldVisible = shouldQuestionOrScreenVisible({
                        conditionalRequirement: nextScreen?.Condition_Requirement__c,
                        conditionalLogic: nextScreen?.Condition_Logic__c,
                        conditionList: nextScreen?.Conditions1__r?.records,
                        questionList: questionsListToValidate,
                    });
                    const questionListOnConditions = nextScreen?.Questions__r?.records?.filter((cQuestion) => {
                        const shouldVisible = shouldQuestionOrScreenVisible({
                            conditionalRequirement: cQuestion?.Condition_Requirement__c,
                            conditionalLogic: cQuestion?.Condition_Logic__c,
                            conditionList: cQuestion?.Conditions2__r?.records,
                            questionList: questionsListToValidate,
                        });
                        if (shouldVisible) {
                            return true;
                        }
                        return false;
                    });

                    if (shouldVisible && questionListOnConditions?.length > 0) {
                        break;
                    } else {
                        if (!screenIds.includes(nextScreen?.Id)) {
                            screenIds.push(nextScreen?.Id);
                        }
                        steps = steps + 1;
                    }
                }

                if (currentStep + steps >= localAllScreenData.length) {
                    text = 'Submit';
                } else {
                    text = 'Next';
                }
            }
        }

        return text;
    };

    const handleNextStep = () => {
        const surveyId = searchParams.get('surveyId');
        const contactId = searchParams.get('contactId');
        if (surveyId && (contactId || mode === 'public')) {
            if (!publicResponseId) {
                if (withLogin && !userDetails?.contact?.id) {
                    return;
                }

                post('custom/createSurveyResponsePublic', { surveyId: surveyId, contactId: withLogin ? userDetails.contact.id : contactId }).then((result) => {
                    if (result.isSuccess && result.data) {
                        setCurrentStep(0);
                        setPublicResponseId(result.data);
                        setStatus(STATUS_CONSTANTS.inProgress);
                        const next = new URLSearchParams(searchParams);
                        next.set('publicResponseId', result.data);
                        setSearchParams(next, { replace: true });
                    }
                });
            } else {
                setCurrentStep(0);
                setStatus(STATUS_CONSTANTS.inProgress);
            }
        }
    };

    const getInstructionText = (textData) => {
        if (!textData) {
            return `<p><b>Welcome ${mode === 'public' ? 'There' : userDetails.contact.firstName}!</b></p>
<p style="margin-top: 1rem; margin-bottom: 1rem">
  You’re about to begin an assessment designed to understand where you are today and guide what comes next.
  There are no trick questions—just answer honestly and do your best.
</p>
<p><strong>Before you begin:</strong></p>
<ul>
  <li>Make sure your connection is stable.</li>
  <li>If something doesn’t apply, choose the closest option or skip where allowed.</li>
  <li>You can review your answers before submitting.</li>
</ul>
<p>
  When you’re ready, click <strong>Start</strong>.
</p>`;
        }
        textData = textData?.replace('{{Name}}', mode === 'public' ? 'There' : userDetails.contact.firstName);
        return textData;
    };

    const getSummaryText = (textData) => {
        if (!textData) {
            return `Thanks—your responses have been submitted.
We’re validating your answers and preparing a summary.`;
        }
        textData = textData?.replace('{{Name}}', userDetails?.contact?.firstName);
        return textData;
    };

    const getCompletionText = (textData) => {
        if (!textData) {
            return `Thanks—your responses have been completed.
We’re validating your answers and preparing a summary.`;
        }
        textData = textData?.replace('{{Name}}', userDetails?.contact?.firstName);
        return textData;
    };

    const handleReviewAnswersClick = (screenId, screen) => {
        const surveyId = searchParams.get('surveyId');
        const contactId = searchParams.get('contactId');

        if (screen === 'Completion Screen') {
            setCurrentStep(0);
            setAllData((prevData) => ({
                ...prevData,
                lastVisitedScreenId: '',
                status: 'Submitted',
            }));
        } else if (screen === 'Submitted Screen') {
            // setIsLoadingReviewAnswers(true);
            // get('custom/updateLastScreen', { recordId: surveyId, contactId: contactId, screenId: screenId }).then((result) => {
            // window.location.reload();
            handleGetSurvey('reviewClicked');
            // setIsLoadingReviewAnswers(false);
            setJustSubmitted(false);
            // });
        } else {
            setIsLoadingReviewAnswers(true);
            if (withLogin && !userDetails?.contact?.id) {
                return;
            }

            post(mode === 'public' ? 'custom/updateLastScreenPublic' : 'custom/updateLastScreen', {
                recordId: surveyId,
                contactId: withLogin ? userDetails.contact.id : contactId,
                screenId: screenId,
                publicResponseId: publicResponseId,
            }).then((result) => {
                window.location.reload();
            });
        }
    };

    const getIsLock = () => {
        return allData.lockAfterSubmission === 'Yes' && allData.status === 'Submitted';
    };
    const getIsNotLock = () => {
        return allData.lockAfterSubmission === 'No' && allData.status === 'Submitted';
    };

    const getSummeryScreen = () => {
        return (
            <>
                <Alert variant="filled" severity="error" sx={{ fontSize: '14px' }}>
                    Looks like a few required questions were left blank. Kindly complete all mandatory fields, then submit your assessment.
                </Alert>
                <Box>
                    {getSkippedQuestions().map((item) => (
                        <Card sx={{ mt: '1rem', cursor: 'pointer' }} onClick={() => handleReviewAnswersClick(item.Screen__c)}>
                            <CardHeader
                                sx={{ padding: '16px 16px 0px' }}
                                title={
                                    <Box component={'span'} color={'brandPrimary.500'}>
                                        {item.screenName}
                                    </Box>
                                }
                            ></CardHeader>
                            <CardContent>{item.Label__c}</CardContent>
                        </Card>
                    ))}
                </Box>
            </>
        );
    };

    if (allDataError) {
        return (
            <MainContainer>
                <Typography variant="h5" fontWeight={600} gutterBottom>
                    {allDataError}
                </Typography>
            </MainContainer>
        );
    }
    if (allData === '') {
        return (
            <MainContainer
                style={{
                    maxWidth: mode === 'public' ? '865px' : '100%',
                    background: mode === 'public' ? 'white' : 'inherit',
                    margin: mode === 'public' ? 'auto' : 'auto',
                    minHeight: '100vh',
                    ...(mode === 'public' ? { height: 'unset' } : {}),
                }}
            >
                {mode === 'public' && (
                    <Box sx={{ mb: '2rem' }}>
                        <Box display="flex" justifyContent="center">
                            <img src={logo} height={40} width={120} alt="Logo" />
                        </Box>
                    </Box>
                )}
                {mode !== 'public' && (
                    <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        flexDirection={{
                            md: 'row',
                            xs: 'column',
                        }}
                        textAlign={mode === 'public' ? 'center' : 'inherit'}
                    >
                        <MainHeading sx={{ width: '100%' }}>Prime Assessment</MainHeading>
                    </Box>
                )}
                <Divider
                    sx={(theme) => ({
                        margin: `${theme.typography.generic.xxxxxLarge} 0`,
                    })}
                />
                <NoDataPresentUI
                    variant={'outlined'}
                    containerSx={{
                        width: {
                            xs: '100%',
                            sm: '100%',
                            md: '100%',
                        },
                        height: '20rem',
                    }}
                    heading={
                        <>
                            <Typography variant="h5" fontWeight={600} gutterBottom>
                                No access
                            </Typography>
                            <Typography variant="body1" color="text.secondary" gutterBottom>
                                You don't have access to this assessment, please contact the Sales team.
                            </Typography>
                        </>
                    }
                    icon={<BlankIcon />}
                />
            </MainContainer>
        );
    }

    const SubmittedScreenUI = ({ isJustSubmitted }) => {
        return (
            <>
                {allData?.completionURL ? (
                    <NavigateExternalURL url={allData?.completionURL} reviewSurvey={searchParams.get('review-survey')} />
                ) : (
                    <ConfirmationScreen
                        content={
                            <Box>
                                <TextDisplay textString={isJustSubmitted ? getSummaryText(allData?.submittedScreenMessage) : getCompletionText(allData?.completionMessage)}></TextDisplay>
                            </Box>
                        }
                        footerButton={
                            <Box
                                sx={(theme) => ({
                                    '& .loading-button': {
                                        marginRight: '1rem',
                                        [theme.breakpoints.down('sm')]: {
                                            width: '100%',
                                            marginBottom: '0',
                                            marginTop: '1rem',
                                        },
                                    },
                                })}
                            >
                                <LoadingButton
                                    className="loading-button"
                                    loading={isLoadingReviewAnswers}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleReviewAnswersClick('', isJustSubmitted ? 'Submitted Screen' : 'Completion Screen')}
                                    sx={() => ({
                                        background: 'white',
                                        border: '1px solid #0056fc',
                                        color: '#0056fc',
                                        '&:hover': {
                                            color: 'white !important',
                                        },
                                    })}
                                >
                                    Review Answers
                                </LoadingButton>
                                {completionActions?.length > 0 &&
                                    completionActions.map((action) => (
                                        <LoadingButton className="loading-button" variant="contained" color="primary" onClick={() => navigateTo(action.url)}>
                                            {action.name}
                                        </LoadingButton>
                                    ))}
                            </Box>
                        }
                        containerStyle={{
                            overflow: 'auto',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            height: 'unset',
                            padding: '20px',

                            maxHeight: {
                                xs: '100%',
                            },

                            '& .icon svg': {
                                minWidth: '130px',
                                minHeight: '130px',
                            },
                        }}
                    />
                )}
            </>
        );
    };

    const totalScreens = localAllScreenData.filter((scr) => !scr.skipped);
    const currentScreenData = localAllScreenData[currentStep ? currentStep : 0];

    const navigateTo = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return (
        <MainContainer
            style={{
                maxWidth: mode === 'public' ? '865px' : '100%',
                background: mode === 'public' ? 'white' : 'inherit',
                margin: mode === 'public' ? 'auto' : 'auto',
                minHeight: '100vh',
                ...(mode === 'public' ? { height: 'unset' } : {}),
            }}
        >
            <Box>
                {mode === 'public' && (
                    <Box sx={{ mb: '3rem' }}>
                        <Box display="flex" justifyContent="center">
                            <img src={logo} height={40} width={120} alt="Logo" />
                        </Box>
                    </Box>
                )}
                <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    flexDirection={{
                        md: mode === 'public' ? 'column' : 'row',
                        xs: 'column',
                    }}
                    textAlign={mode === 'public' ? 'center' : 'inherit'}
                    gap={mode === 'public' ? '1rem' : 'inherit'}
                >
                    <MainHeading sx={{ width: '100%', mb: mode === 'public' ? '1rem' : '0rem' }}>
                        {allData?.name}{' '}
                        {getIsLock() ? (
                            <span style={{ fontSize: '20px', color: '#000000' }}>
                                <Tooltip title="Your responses are locked." arrow>
                                    <LockIcon />
                                </Tooltip>
                            </span>
                        ) : null}
                    </MainHeading>
                    {loading ? null : <Steps mode={mode} currentStep={currentStep} totalScreens={totalScreens} currentScreenData={currentScreenData} />}
                </Box>
                <Divider
                    sx={(theme) => ({
                        margin: `${theme.typography.generic.xxxxxLarge} 0`,
                    })}
                />

                {loading ? (
                    <CircularProgress sx={{ display: 'flex', justifySelf: 'center' }} />
                ) : status === STATUS_CONSTANTS.notStarted ? (
                    <InstructionScreen content={getInstructionText(allData?.instructionScreen)} handleStart={handleNextStep} />
                ) : displaySummaryScreen || allData.lastVisitedScreenId === 'Summery Screen' ? (
                    <>{getSummeryScreen()}</>
                ) : status === STATUS_CONSTANTS.submitted && justSubmitted ? (
                    <SubmittedScreenUI isJustSubmitted={true} />
                ) : status === STATUS_CONSTANTS.submitted && allData.lastVisitedScreenId === 'Last Screen' ? (
                    <SubmittedScreenUI isJustSubmitted={false} />
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // width:"50%",
                            // maxWidth:"50%",
                        }}
                    >
                        <Typography component={'h3'} variant="heading2" fontFamily={'fontFamilyCondensed'} color={'text.primary'} marginBottom={'1.5rem'}>
                            {currentScreenData?.Name}
                        </Typography>
                        {currentScreenData?.Type__c === 'Repeatable' ? (
                            <RepeatableScreen
                                currentStep={currentStep}
                                handleSetVisibility={handleSetVisibility}
                                currentScreenData={currentScreenData}
                                questionsList={currentScreenData?.Questions__r?.records || []}
                                questionsListToValidate={evaluateQuestionsList() || []}
                                validate={validate}
                                handleRepeatableDataSave={handleRepeatableDataSave}
                                cardList={currentScreenData?.cardList?.filter((c) => !c.isEmpty) || []}
                                error={repeatScreenError}
                                setRepeatScreenError={setRepeatScreenError}
                                isLock={getIsLock()}
                                contactId={publicResponseId}
                                ref={repeatScreenRef}
                            />
                        ) : (
                            <GeneralScreen
                                currentStep={currentStep}
                                questionsList={currentScreenData?.Questions__r?.records || []}
                                questionsListToValidate={evaluateQuestionsList() || []}
                                shouldQuestionOrScreenVisible={shouldQuestionOrScreenVisible}
                                handleDataChange={handleDataChange}
                                handleSetVisibility={handleSetVisibility}
                                screenId={currentScreenData?.Id}
                                isLock={getIsLock()}
                                contactId={publicResponseId}
                            />
                        )}

                        <Box
                            sx={(theme) => ({
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '2.5rem',
                                paddingBottom: '2rem',

                                [theme.breakpoints.down('sm')]: {
                                    width: '100%',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                },
                            })}
                        >
                            <Box width={'100%'}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    disabled={currentStep === 0}
                                    onClick={handleBackStep}
                                    sx={(theme) => ({
                                        marginRight: '1rem',
                                        [theme.breakpoints.down('sm')]: {
                                            width: '100%',
                                            marginBottom: '10px',
                                        },
                                    })}
                                >
                                    Back
                                </Button>
                                {!getIsLock() && (
                                    <LoadingButton
                                        loading={skipButtonLoading}
                                        variant="contained"
                                        color="secondary"
                                        onClick={
                                            currentScreenData?.Type__c === 'Repeatable'
                                                ? () => handleRepeatableScreenNextButton({ isScreenSkipButtonClicked: true })
                                                : () => handleNextButton({ isScreenSkipButtonClicked: true })
                                        }
                                        sx={(theme) => ({
                                            marginRight: '1rem',
                                            [theme.breakpoints.down('sm')]: {
                                                width: '100%',
                                                marginBottom: '8px',
                                            },
                                        })}
                                    >
                                        Skip
                                    </LoadingButton>
                                )}
                                <LoadingButton
                                    loading={postLoading}
                                    variant="contained"
                                    color="primary"
                                    onClick={currentScreenData?.Type__c === 'Repeatable' ? handleRepeatableScreenNextButton : handleNextButton}
                                    sx={(theme) => ({
                                        marginRight: '1rem',
                                        [theme.breakpoints.down('sm')]: {
                                            width: '100%',
                                            marginBottom: '8px',
                                        },
                                    })}
                                >
                                    {evaluateButtonText()}
                                </LoadingButton>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </MainContainer>
    );
}

export default PrimeAssessment;
